export interface ICreatePagePreviewInput {
  title: string;
  body: string;
  imageUrl: string;
  organizationId: string;
}

class CreatePagePreviewInput {
  public readonly title: string;
  public readonly body: string;
  public readonly imageUrl: string;
  public readonly organizationId: string;

  constructor({
    title,
    body,
    imageUrl,
    organizationId,
  }: {
    title: string;
    body: string;
    imageUrl: string;
    organizationId: string;
  }) {
    this.title = title;
    this.body = body;
    this.imageUrl = imageUrl;
    this.organizationId = organizationId;
  }

  public toJSON = () => ({
    title: this.title,
    body: this.body,
    imageUrl: this.imageUrl,
    organizationId: this.organizationId,
  });

  public static fromJSON = (json: ICreatePagePreviewInput): CreatePagePreviewInput => {
    const { title, body, imageUrl, organizationId } = Object.assign({}, json);

    if (typeof title !== 'string') throw new Error('.title must be a string');
    if (typeof body !== 'string') throw new Error('.body must be a string');
    if (typeof imageUrl !== 'string') throw new Error('.imageUrl must be a string');
    if (typeof organizationId !== 'string') throw new Error('.organizationId must be a string');

    return new CreatePagePreviewInput({
      title,
      body,
      imageUrl,
      organizationId,
    });
  };
}

export default CreatePagePreviewInput;
